import {
    Component,
    computed,
    effect,
    output,
    ChangeDetectionStrategy
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectComponent } from "@ng-select/ng-select";
import { AlertItem } from "../alert-list.component";

type SortMethod = keyof AlertItem;
type SortDirection = "asc" | "desc";

type SortOption<T> = {
    label: string;
    value: T;
};

type SortForm = FormGroup<{
    method: FormControl<SortMethod>;
    direction: FormControl<SortDirection>;
}>;

export type AlertListSortSettings = {
    method: SortMethod | null;
    direction: SortDirection;
};

@Component({
    selector: "rask-alert-list-sort",
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgbPopover,
        NgSelectComponent
    ],
    templateUrl: "./alert-list-sort.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./alert-list-sort.component.scss"
})
export class AlertListSortComponent {
    readonly sortChanged = output<AlertListSortSettings>();

    protected readonly sortOptions: SortOption<SortMethod>[] = [
        {
            label: "Titel",
            value: "title"
        },
        {
            label: "Händelse",
            value: "message"
        },
        {
            label: "Allvarlighet",
            value: "severity"
        }
    ];

    protected readonly sortDirectionOptions: SortOption<SortDirection>[] = [
        {
            label: "Stigande",
            value: "asc"
        },
        {
            label: "Fallande",
            value: "desc"
        }
    ];

    protected readonly sortForm: SortForm = new FormGroup({
        method: new FormControl<SortMethod | null>(null),
        direction: new FormControl<SortDirection>("asc", {
            nonNullable: true
        })
    });

    protected readonly sortFormValue = toSignal(this.sortForm.valueChanges, {
        initialValue: this.sortForm.getRawValue()
    });

    protected readonly sortSettings = computed<AlertListSortSettings>(() => {
        const value = this.sortFormValue();

        return {
            method: value.method,
            direction: value.direction
        };
    });

    constructor() {
        effect(() => {
            this.sortChanged.emit(this.sortSettings());
        });
    }
}
